import { Heart } from "lucide-react";
import { MARQUEE_ITEMS } from "@/data/content";

export default function Marquee() {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div data-testid="editorial-marquee" className="bg-[#2C221E] py-5 overflow-hidden border-y border-[#2C221E]">
      <div className="animate-marquee flex w-max items-center gap-10 pr-10">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10 whitespace-nowrap">
                <span className={`font-serif text-xl sm:text-2xl ${i % 2 ? "italic text-[#F8C8DC]" : "text-[#FAF7F2]"}`}>
                  {item}
                </span>
                <Heart className="w-4 h-4 text-[#C86D51] fill-current shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
